const CATEGORIES = {
    'car_ad': 'Samochody osobowe',
    'truck_ad': 'Samochody dostawcze',
    'motorcycle_ad': 'Motocykle',
    'part_ad': 'Części',
    'tool_ad': 'Narzędzia warsztatowe',
    'service_ad': 'Serwisy samochodowe',
    'agri_ad': 'Maszyny rolnicze',
    'budowlane': 'Maszyny budowlane',
    'przyczepy': 'Przyczepy',
    'ciezarowe': 'Samochody ciężarowe',
    'deleted': 'Zakończone',
}

const SHORT_CATEGORIES = {
    'car_ad': 'Osobowe',
    'truck_ad': 'Dostawcze',
    'motorcycle_ad': 'Motocykle',
    'part_ad': 'Części',
    'tool_ad': 'Narzędzia',
    'service_ad': 'Serwisy',
    'agri_ad': 'Rolnicze',
    'budowlane': 'Budowlane',
    'przyczepy': 'Przyczepy',
    'ciezarowe': 'Ciężarowe',
    'deleted': 'Zakończone',
}

export default CATEGORIES
export {
    SHORT_CATEGORIES,
}